import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// [GET] /account
export const fetchAccount = createAsyncThunk(
  "/api/account/fetchAccount",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch("/api/account", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error === 1) {
        throw new Error("API returned error");
      }

      return data.data; // 回傳 account 資料物件
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// [POST] /account
export const updateAccount = createAsyncThunk(
  "/api/account/updateAccount",
  async (accountData, { rejectWithValue }) => {
    try {
      const response = await fetch("/api/account", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(accountData),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.error === 1) {
        throw new Error("API returned error");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const accountSlice = createSlice({
  name: "account",
  initialState: {
    account: null, // { account, password, name, mobile, address, company_id, contract_capacity }
    isLoading: false,
    isUpdating: false,
    error: null,
    updateError: null,
  },
  reducers: {
    clearAccountError: (state) => {
      state.error = null;
      state.updateError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET
      .addCase(fetchAccount.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.account = action.payload;
      })
      .addCase(fetchAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // POST
      .addCase(updateAccount.pending, (state) => {
        state.isUpdating = true;
        state.updateError = null;
      })
      .addCase(updateAccount.fulfilled, (state) => {
        state.isUpdating = false;
      })
      .addCase(updateAccount.rejected, (state, action) => {
        state.isUpdating = false;
        state.updateError = action.payload;
      });
  },
});

export const { clearAccountError } = accountSlice.actions;

// Selectors
export const selectAccount = (state) => state.account.account;
export const selectAccountLoading = (state) => state.account.isLoading;
export const selectAccountUpdating = (state) => state.account.isUpdating;
export const selectAccountError = (state) => state.account.error;
export const selectAccountUpdateError = (state) => state.account.updateError;

export default accountSlice.reducer;
